import React from 'react'

import { MAX_CARD_COUNT } from './Constants'

function SkeletonCard() {
  return (
    <div className="card-3d-model upsell-block__skeleton-card">
      <article className="card-3d-model__article">
        <div className="upsell-block__skeleton-image" />
        <div className="upsell-block__skeleton-footer">
          <div className="upsell-block__skeleton-line upsell-block__skeleton-line--title" />
        </div>
      </article>
    </div>
  )
}

function Skeleton() {
  return (
    <div className="upsell-block col-12" aria-hidden="true">
      <div className="card-3d-model upsell-block__promo-slot">
        <div className="upsell-block__promo-inner">
          <div className="upsell-block__skeleton-line upsell-block__skeleton-line--sm" />
          <div className="upsell-block__promo-text">
            <div className="upsell-block__skeleton-line upsell-block__skeleton-line--lg" />
            <div className="upsell-block__skeleton-line upsell-block__skeleton-line--md" />
          </div>
          <div className="upsell-block__skeleton-line upsell-block__skeleton-line--btn" />
        </div>
      </div>
      {Array.from({ length: MAX_CARD_COUNT }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  )
}

export default Skeleton
